import moment from 'moment';
import { DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_DATA, DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_ERROR, DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_SUCCESS, DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_DATA, DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_ERROR, DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_SUCCESS, DAS_COUNT_GRAPH_INJECTION_AMP_DATA, DAS_COUNT_GRAPH_INJECTION_AMP_ERROR, DAS_COUNT_GRAPH_INJECTION_AMP_SUCCESS, DAS_GRAPH_AMP_DATA, DAS_GRAPH_AMP_DEPTH_DATA, DAS_GRAPH_AMP_ERROR, DAS_GRAPH_AMP_SUCCESS, DAS_GRAPH_AMP_TIME_DATA, DAS_GRAPH_DATA, DAS_GRAPH_DATA_ERROR, DAS_GRAPH_DATA_SUCCESS, DAS_GRAPH_INJECTION_AMP_DATA, DAS_GRAPH_INJECTION_AMP_ERROR, DAS_GRAPH_INJECTION_AMP_SUCCESS, DAS_GRAPH_LEAK_AMP_DATA, DAS_GRAPH_LEAK_AMP_ERROR, DAS_GRAPH_LEAK_AMP_SUCCESS, DAS_GRAPH_MICROSEISMIC_AMP_DATA, DAS_GRAPH_MICROSEISMIC_AMP_ERROR, DAS_GRAPH_MICROSEISMIC_AMP_SUCCESS, DAS_GRAPH_SAND_AMP_DATA, DAS_GRAPH_SAND_AMP_ERROR, DAS_GRAPH_SAND_AMP_SUCCESS, DAS_GRAPH_TIME_DATA, DAS_GRAPH_TIME_ERROR, DAS_GRAPH_TIME_EVENT, DAS_GRAPH_TIME_SUCCESS, DAS_LIST_ANOMALIES_AMP_DATA, DAS_LIST_ANOMALIES_AMP_ERROR, DAS_LIST_ANOMALIES_AMP_SUCCESS, DAS_LIST_INJECTION_AMP_DATA, DAS_LIST_INJECTION_AMP_ERROR, DAS_LIST_INJECTION_AMP_SUCCESS, DAS_LIST_MICROSEISMIC_AMP_DATA, DAS_LIST_MICROSEISMIC_AMP_ERROR, DAS_LIST_MICROSEISMIC_AMP_SUCCESS, DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_DATA, DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_ERROR, DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_SUCCESS, DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_DATA, DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_ERROR, DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_SUCCESS, DTS_COUNT_GRAPH_INJECTION_TEMP_DATA, DTS_COUNT_GRAPH_INJECTION_TEMP_ERROR, DTS_COUNT_GRAPH_INJECTION_TEMP_SUCCESS, DTS_GRAPH, DTS_GRAPH_DATA, DTS_GRAPH_DATA_ERROR, DTS_GRAPH_DATA_SUCCESS, DTS_GRAPH_INJECTION_TEMP_DATA, DTS_GRAPH_INJECTION_TEMP_ERROR, DTS_GRAPH_INJECTION_TEMP_SUCCESS, DTS_GRAPH_LEAK_TEMP_DATA, DTS_GRAPH_LEAK_TEMP_ERROR, DTS_GRAPH_LEAK_TEMP_SUCCESS, DTS_GRAPH_MICROSEISMIC_TEMP_DATA, DTS_GRAPH_MICROSEISMIC_TEMP_ERROR, DTS_GRAPH_MICROSEISMIC_TEMP_SUCCESS, DTS_GRAPH_SAND_TEMP_DATA, DTS_GRAPH_SAND_TEMP_ERROR, DTS_GRAPH_SAND_TEMP_SUCCESS, DTS_GRAPH_TEMP_DATA, DTS_GRAPH_TEMP_DEPTH_DATA, DTS_GRAPH_TEMP_ERROR, DTS_GRAPH_TEMP_SUCCESS, DTS_GRAPH_TEMP_TIME_DATA, DTS_GRAPH_TIME_DATA, DTS_GRAPH_TIME_ERROR, DTS_GRAPH_TIME_EVENT, DTS_GRAPH_TIME_SUCCESS, DTS_LIST_ANOMALIES_TEMP_DATA, DTS_LIST_ANOMALIES_TEMP_ERROR, DTS_LIST_ANOMALIES_TEMP_SUCCESS, DTS_LIST_INJECTION_TEMP_DATA, DTS_LIST_INJECTION_TEMP_ERROR, DTS_LIST_INJECTION_TEMP_SUCCESS } from './constants';


export default function reportWellReducer(state, action) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const das_list_microseismic_amp_data = [];

	const das_list_injection_amp_data = [];
	const dts_list_injection_temp_data = [];

	const das_list_anomalies_amp_data = [];
	const dts_list_anomalies_temp_data = [];


	
	switch (action.type) {
	case DTS_GRAPH : 	
		return { ...state, dasData: action.dasData, dtsData : action.dtsData };

	case DAS_GRAPH_DATA : 	
		return { ...state, dasbarpending: true };
	case DAS_GRAPH_DATA_SUCCESS:
		return { ...state, das_data: action.payload, dasbarpending: false };
	case DAS_GRAPH_DATA_ERROR:
		return { ...state, error: true, dasbarpending:false };

	case DAS_GRAPH_TIME_DATA : 	
		return { ...state, dastimeeventpending: true };
	case DAS_GRAPH_TIME_SUCCESS:
		return { ...state, das_time_data: action.payload, dastimeeventpending: false };
	case DAS_GRAPH_TIME_ERROR:
		return { ...state, error: true, dastimeeventpending:false };

	case DAS_GRAPH_TIME_EVENT : 	
		return { ...state, dasTimeEventData: action.payload};
	
	case DTS_GRAPH_TIME_EVENT : 	
		return { ...state, dtsTimeEventData: action.payload};


	case DTS_GRAPH_DATA : 	
		return { ...state, dtsbarpending: true };
	case DTS_GRAPH_DATA_SUCCESS:
		return { ...state, dts_data: action.payload, dtsbarpending: false };
	case DTS_GRAPH_DATA_ERROR:
		return { ...state, error: true, dtsbarpending:false };

	case DTS_GRAPH_TIME_DATA : 	
		return { ...state, dtstimeeventpending: true };
	case DTS_GRAPH_TIME_SUCCESS:
		return { ...state, dts_time_data: action.payload, dtstimeeventpending: false };
	case DTS_GRAPH_TIME_ERROR:
		return { ...state, error: true, dtstimeeventpending:false };

	
	case DAS_GRAPH_AMP_DATA : 	
		return { ...state, daspending: true };
	case DAS_GRAPH_AMP_SUCCESS:
		return { ...state, das_amp_data: action.payload, daspending: false };
	case DAS_GRAPH_AMP_ERROR:
		return { ...state, error: true, daspending:false };

	
	case DTS_GRAPH_TEMP_DATA : 	
		return { ...state, dtspending: true };
	case DTS_GRAPH_TEMP_SUCCESS:
		return { ...state, dts_temp_data: action.payload, dtspending: false };
	case DTS_GRAPH_TEMP_ERROR:
		return { ...state, error: true, dtspending:false };

		

	case DAS_GRAPH_AMP_TIME_DATA : 	
		return { ...state, dasTimeAmpData: action.payload};
	
	case DAS_GRAPH_AMP_DEPTH_DATA : 	
		return { ...state, dasDepthAmpData: action.payload};

	case DTS_GRAPH_TEMP_TIME_DATA : 	
		return { ...state, dtsTimeTempData: action.payload};
	
	case DTS_GRAPH_TEMP_DEPTH_DATA : 	
		return { ...state, dtsDepthTempData: action.payload};


	case DAS_GRAPH_INJECTION_AMP_DATA : 	
		return { ...state, dasinjectionheatmappending: true };
	case DAS_GRAPH_INJECTION_AMP_SUCCESS:
		return { ...state, das_injection_amp_data: action.payload, dasinjectionheatmappending: false };
	case DAS_GRAPH_INJECTION_AMP_ERROR:
		return { ...state, error: true, dasinjectionheatmappending:false };

	
	case DTS_GRAPH_INJECTION_TEMP_DATA : 	
		return { ...state, dtsinjectionheatmappending: true };
	case DTS_GRAPH_INJECTION_TEMP_SUCCESS:
		return { ...state, dts_injection_temp_data: action.payload, dtsinjectionheatmappending: false };
	case DTS_GRAPH_INJECTION_TEMP_ERROR:
		return { ...state, error: true, dtsinjectionheatmappending:false };


	case DAS_GRAPH_LEAK_AMP_DATA : 	
		return { ...state, dasleakheatmappending: true };
	case DAS_GRAPH_LEAK_AMP_SUCCESS:
		return { ...state, das_leak_amp_data: action.payload, dasleakheatmappending: false };
	case DAS_GRAPH_LEAK_AMP_ERROR:
		return { ...state, error: true, dasleakheatmappending:false };

	
	case DTS_GRAPH_LEAK_TEMP_DATA : 	
		return { ...state, dtsleakheatmappending: true };
	case DTS_GRAPH_LEAK_TEMP_SUCCESS:
		return { ...state, dts_leak_temp_data: action.payload, dtsleakheatmappending: false };
	case DTS_GRAPH_LEAK_TEMP_ERROR:
		return { ...state, error: true, dtsleakheatmappending:false };

	case DAS_GRAPH_MICROSEISMIC_AMP_DATA : 	
		return { ...state, dasmicroseismiccountpending: true };
	case DAS_GRAPH_MICROSEISMIC_AMP_SUCCESS:		
		return { ...state, das_microseismic_amp_data: action.payload, dasmicroseismiccountpending: false };
	case DAS_GRAPH_MICROSEISMIC_AMP_ERROR:
		return { ...state, error: true, dasmicroseismiccountpending:false };

	
	case DTS_GRAPH_MICROSEISMIC_TEMP_DATA : 	
		return { ...state, pending: true };
	case DTS_GRAPH_MICROSEISMIC_TEMP_SUCCESS:
		return { ...state, dts_microseismic_temp_data: action.payload, pending: false };
	case DTS_GRAPH_MICROSEISMIC_TEMP_ERROR:
		return { ...state, error: true, pending:false };

	case DAS_LIST_MICROSEISMIC_AMP_DATA : 	
		return { ...state, dasmicroseismiclistpending: true };
	case DAS_LIST_MICROSEISMIC_AMP_SUCCESS:
		action.payload && action.payload.data.map((item) => {
			const dateTimeFrom = moment.utc(item.dateTimeFrom).toDate();
			dateTimeFrom.toString();
			const newDateTimeFrom = moment(dateTimeFrom, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			const dateTimeTo = moment.utc(item.dateTimeTo).toDate();
			dateTimeFrom.toString();
			const newDateTimeTo = moment(dateTimeTo, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			das_list_microseismic_amp_data.push({
				id : item.id,
				name : item.name,
				wellinfo : item.wellinfo.name,
				wellseismictypes : item.wellseismictypes.name,
				dateTimeFrom : newDateTimeFrom,
				dateTimeTo : newDateTimeTo,
				depthFrom : item.depthFrom,
				depthTo : item.depthTo,
				status : item.status,
				channelName : item.channelinfo.name
			});
            
		});
		return { ...state, das_list_microseismic_amp_data: das_list_microseismic_amp_data, dasmicroseismiclistpending: false };
	case DAS_LIST_MICROSEISMIC_AMP_ERROR:
		return { ...state, error: true, dasmicroseismiclistpending:false };

	
	case DAS_LIST_INJECTION_AMP_DATA : 	
		return { ...state, dasinjectionlistpending: true };
	case DAS_LIST_INJECTION_AMP_SUCCESS:
		action.payload && action.payload.data.map((item) => {
			const dateTimeFrom = moment.utc(item.datetime).toDate();
			dateTimeFrom.toString();
			const newDateTimeFrom = moment(dateTimeFrom, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			// const dateTimeTo = moment.utc(item.dateTimeTo).toDate();
			// dateTimeFrom.toString();
			// const newDateTimeTo = moment(dateTimeTo, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			dts_list_injection_temp_data.push({
				id : item.id,
				wellname : item.wellname,
				channelname	 : item.channelname	,
				datetime : newDateTimeFrom,
				// dateTimeTo : newDateTimeTo,
				anomaly_type : item.anomaly_type,
				// depthTo : item.depthTo,
				// status : item.status,
				// channelName : item.channelinfo.name
			});
            
		});
		return { ...state, das_list_injection_amp_data: das_list_injection_amp_data, dasinjectionlistpending: false };
	case DAS_LIST_INJECTION_AMP_ERROR:
		return { ...state, error: true, dasinjectionlistpending:false };


	case DTS_LIST_INJECTION_TEMP_DATA : 	
		return { ...state, dtsinjectionlistpending: true };
	case DTS_LIST_INJECTION_TEMP_SUCCESS:
		action.payload && action.payload.data.map((item) => {
			const dateTimeFrom = moment.utc(item.datetime).toDate();
			dateTimeFrom.toString();
			const newDateTimeFrom = moment(dateTimeFrom, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			// const dateTimeTo = moment.utc(item.dateTimeTo).toDate();
			// dateTimeFrom.toString();
			// const newDateTimeTo = moment(dateTimeTo, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			dts_list_injection_temp_data.push({
				id : item.id,
				wellname : item.wellname,
				channelname	 : item.channelname	,
				datetime : newDateTimeFrom,
				// dateTimeTo : newDateTimeTo,
				anomaly_type : item.anomaly_type,
				// depthTo : item.depthTo,
				// status : item.status,
				// channelName : item.channelinfo.name
			});
            
		});
		return { ...state, dts_list_injection_temp_data: dts_list_injection_temp_data, dtsinjectionlistpending: false };
	case DTS_LIST_INJECTION_TEMP_ERROR:
		return { ...state, error: true, dtsinjectionlistpending:false };



	case DAS_LIST_ANOMALIES_AMP_DATA : 	
		return { ...state, dasanomalieslistpending: true };
	case DAS_LIST_ANOMALIES_AMP_SUCCESS:
		action.payload && action.payload.data.map((item) => {
			const dateTimeFrom = moment.utc(item.datetime).toDate();
			dateTimeFrom.toString();
			const newDateTimeFrom = moment(dateTimeFrom, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			// const dateTimeTo = moment.utc(item.dateTimeTo).toDate();
			// dateTimeFrom.toString();
			// const newDateTimeTo = moment(dateTimeTo, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			das_list_anomalies_amp_data.push({
				id : item.id,
				wellname : item.wellname,
				channelname	 : item.channelname	,
				datetime : newDateTimeFrom,
				// dateTimeTo : newDateTimeTo,
				anomaly_type : item.anomaly_type,
				depths : item && item.depths ? item.depths.toFixed(2) : null,
				zone: item.zone,
				// channelName : item.channelinfo.name
			});
            
		});
		return { ...state, das_list_anomalies_amp_data: das_list_anomalies_amp_data, dasanomalieslistpending: false };
	case DAS_LIST_ANOMALIES_AMP_ERROR:
		return { ...state, error: true, dasanomalieslistpending:false };


	case DTS_LIST_ANOMALIES_TEMP_DATA : 	
		return { ...state, dtsanomalieslistpending: true };
	case DTS_LIST_ANOMALIES_TEMP_SUCCESS:
		action.payload && action.payload.data.map((item) => {			
			
			const dateTimeFrom = moment.utc(item.datetime).toDate();
			dateTimeFrom.toString();
			const newDateTimeFrom = moment(dateTimeFrom, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			// const dateTimeTo = moment.utc(item.dateTimeTo).toDate();
			// dateTimeFrom.toString();
			// const newDateTimeTo = moment(dateTimeTo, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			dts_list_anomalies_temp_data.push({
				id : item.id,
				wellname : item.wellname,
				channelname	 : item.channelname	,
				datetime : newDateTimeFrom,
				// dateTimeTo : newDateTimeTo,
				anomaly_type : item.anomaly_type,
				depths : item && item.depths ? item.depths.toFixed(2) : null,
				zone: item.zone,
				// channelName : item.channelinfo.name
			});
            
		});
		return { ...state, dts_list_anomalies_temp_data: dts_list_anomalies_temp_data, dtsanomalieslistpending: false };
	case DTS_LIST_ANOMALIES_TEMP_ERROR:
		return { ...state, error: true, dtsanomalieslistpending:false };

	
	case DAS_GRAPH_SAND_AMP_DATA : 	
		return { ...state, dassandheatmappending: true };
	case DAS_GRAPH_SAND_AMP_SUCCESS:
		return { ...state, das_sand_amp_data: action.payload, dassandheatmappending: false };
	case DAS_GRAPH_SAND_AMP_ERROR:
		return { ...state, error: true, dassandheatmappending:false };

	
	case DTS_GRAPH_SAND_TEMP_DATA : 	
		return { ...state, dtssandheatmappending: true };
	case DTS_GRAPH_SAND_TEMP_SUCCESS:
		return { ...state, dts_sand_temp_data: action.payload, dtssandheatmappending: false };
	case DTS_GRAPH_SAND_TEMP_ERROR:
		return { ...state, error: true, dtssandheatmappending:false };

	case DAS_COUNT_GRAPH_INJECTION_AMP_DATA : 	
		return { ...state, dasinjectioncountpending: true };
	case DAS_COUNT_GRAPH_INJECTION_AMP_SUCCESS:
		return { ...state, das_injection_count_amp_data: action.payload, dasinjectioncountpending: false };
	case DAS_COUNT_GRAPH_INJECTION_AMP_ERROR:
		return { ...state, error: true, dasinjectioncountpending:false };

	case DTS_COUNT_GRAPH_INJECTION_TEMP_DATA : 	
		return { ...state, dtsinjectioncountpending: true };
	case DTS_COUNT_GRAPH_INJECTION_TEMP_SUCCESS:
		return { ...state, dts_injection_count_temp_data: action.payload, dtsinjectioncountpending: false };
	case DTS_COUNT_GRAPH_INJECTION_TEMP_ERROR:
		return { ...state, error: true, dtsinjectioncountpending:false };

	case DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_DATA : 	
		return { ...state, dasleakcountpending: true };
	case DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_SUCCESS:
		return { ...state, das_anomalies_leak_count_amp_data: action.payload, dasleakcountpending: false };
	case DAS_COUNT_GRAPH_ANOMALIES_LEAK_AMP_ERROR:
		return { ...state, error: true, dasleakcountpending:false };

	case DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_DATA : 	
		return { ...state, dtsleakcountpending: true };
	case DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_SUCCESS:
		return { ...state, dts_anomalies_leak_count_temp_data: action.payload, dtsleakcountpending: false };
	case DTS_COUNT_GRAPH_ANOMALIES_LEAK_TEMP_ERROR:
		return { ...state, error: true, dtsleakcountpending:false };

	case DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_DATA : 	
		return { ...state, dassandcountpending: true };
	case DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_SUCCESS:
		return { ...state, das_anomalies_sand_count_amp_data: action.payload, dassandcountpending: false };
	case DAS_COUNT_GRAPH_ANOMALIES_SAND_AMP_ERROR:
		return { ...state, error: true, dassandcountpending:false };

	case DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_DATA : 	
		return { ...state, dtssandcountpending: true };
	case DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_SUCCESS :
		return { ...state, dts_anomalies__sand_temp_data: action.payload, dtssandcountpending: false };
	case DTS_COUNT_GRAPH_ANOMALIES_SAND_TEMP_ERROR:
		return { ...state, error: true, dtssandcountpending:false };
		

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}